import { useEffect } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { useController, useFormContext } from "react-hook-form";
import { format } from "date-fns";

const DateInput = ({
  name,
  id,
  asSingle = true,
  useRange = false,
  placeholder = false,
  startDate = "",
  validateDate,
  start_day_value,
  end_day_value,
  flag,
}) => {
  const { clearErrors, setValue } = useFormContext();
  const controllerProps = {
    name: id,
    rules: {
      required: {
        value: true,
        message: `Le champs ${name.toLowerCase()} est requis.`,
      },
    },
  };
  // Gestion des valeurs par défaut.
  if (start_day_value && end_day_value) {
    controllerProps["defaultValue"] = {
      startDate: start_day_value,
      endDate: end_day_value,
    };
  } else if (start_day_value && asSingle === true) {
    controllerProps["defaultValue"] = {
      startDate: start_day_value,
      endDate: start_day_value,
    };
  }
  if (validateDate) {
    controllerProps["rules"]["validate"] = validateDate;
  }

  const { field } = useController(controllerProps);
  const disablePastDates = (date) => {
    const currentDate = new Date().setHours(0, 0, 0, 0);
    const selectedDate = new Date(date).setHours(0, 0, 0, 0);
    if (startDate && selectedDate.getTime() < new Date(startDate).getTime()) {
      return true;
    }
    return selectedDate < currentDate;
  };

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 7);
  const tomorrowDate = currentDate.toISOString().split("T")[0];

  const today = new Date();
  const firstDateOfMonth = format(today, "yyyy-MM-01");
  useEffect(() => {
    if (
      flag === "EDIT_RETURN_DATE" &&
      start_day_value &&
      field.value?.startDate !== start_day_value
    ) {
      setValue(id, {
        startDate: start_day_value,
        endDate: start_day_value,
      });
    }
  }, [field.value?.startDate, id, setValue, start_day_value, flag]);
  return (
    <>
      <Datepicker
        startWeekOn="mon"
        placeholder={placeholder}
        i18n={"fr"}
        primaryColor={"blue"}
        value={field.value}
        useRange={useRange}
        onChange={(e) => {
          // send data to react hook form
          clearErrors();
          field.onChange(e);
        }}
        asSingle={asSingle}
        displayFormat="DD/MM/YYYY"
        inputName={name}
        inputId={field.name}
        startFrom={firstDateOfMonth}
        minDate={id !== "weddingdate" ? tomorrowDate : null}
        maxDate={new Date().setDate(currentDate.getDate() + 365)}
        beforeRenderDay={(date) => ({
          disabled: disablePastDates(date),
        })}
      />
    </>
  );
};

export default DateInput;
